// Role helpers — mirror backend app/core/access.py.
export const ADMIN_ROLES = ['ADMIN', 'DESIGNATED_ADMIN', 'PRIMARY_ADMIN', 'ARCHITECT']

export const isAdminRole = (role?: string | null) => !!role && ADMIN_ROLES.includes(role)
export const isTeacherRole = (role?: string | null) => role === 'TEACHER'
export const isParentRole = (role?: string | null) => role === 'PARENT'
